import styled from 'styled-components';

export const ForgotPasswordLinkWrapper = styled.div`
    text-align: right;
    margin-top: 5px;
`;